export { default as dashboardRoutes } from './dashboard';
export { default as botSettingsRoutes } from './settings';
export { default as botQuestionRoutes } from './question';
export { default as liveChatSettingsRoutes } from './liveChatSettings';
